import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { timeresolutionindicdata } from "variables/lists/charts";

import { charttext } from "variables/chart";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import DataTable from "react-data-table-component";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;



function AddIndicDialog(props) {
  const { closeModal, indicatordata, formula, setFormula, serie } = props;

  const [prefilteredIndicators, setPrefilteredIndicators] = useState(indicatordata);

  const [timeresolution, setTimeresolution] = useState("all");


  const handleTimeresolutionChange = (event) => { setTimeresolution(event.target.value); };

  useEffect(() => {
    let tmpprefilteredIndicators = [...indicatordata];
    if (timeresolution !== 'all') {
      tmpprefilteredIndicators = tmpprefilteredIndicators.filter((indic) => indic.timeresolution === timeresolution);
    }
    setPrefilteredIndicators(tmpprefilteredIndicators);
  }, [timeresolution]);

  const classes = useStyles();


  const handleSubmit = (indic) => {
    let formulatmp = formula;
    formulatmp += "{I,"+indic.id+",SUM,false,none,none}";
    setFormula(formulatmp, serie);
    closeModal();

  };


  const indicsColumns = [
    {
      name: charttext.indicname,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name
    },
    {
      name: charttext.indicgranularity,
      selector: (row) => row.timeresolution,
      sortable: true,
      cell: (row) => timeresolutionindicdata.find((a) => a.id == row.timeresolution)?.name || ""
    },
    {
      name: charttext.indicdescription,
      selector: (row) => row.description,
      sortable: true,
      cell: (row) => row.description
    },
  ]

  const [filterTextChart, setFilterTextChart] = useState("");
  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  const SearchComponentChart = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
  const filteredItemsCharts = prefilteredIndicators.filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterTextChart.toLowerCase())) ||
      (item.description && item.description.toLowerCase().includes(filterTextChart.toLowerCase()))
  );
  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
      if (filterTextChart) {
        setResetPaginationToggleChart(!resetPaginationToggleChart);
        setFilterTextChart("");
      }
    };
    const onFilterTextChart = (e) => setFilterTextChart(e.target.value);

    return (
      <>
        <TableName>Indicateurs disponibles</TableName>
        <SearchComponentChart
          key="SearchComponentChart"
          onFilter={onFilterTextChart}
          onClear={handleClearChart}
          filterText={filterTextChart}
        />
      </>
    );
  }, [filterTextChart, resetPaginationToggleChart, prefilteredIndicators]);


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <GridContainer>
                    <GridItem xs={12} sm={7} md={7}>
                      <div>
                        <CustomSelect
                          inputTitle={charttext.indicgranularity}
                          selectValue={timeresolution}
                          handleSelectValueChange={handleTimeresolutionChange}
                          data={timeresolutionindicdata}
                        />
                      </div>
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                    noDataComponent={<NoData>{"Aucun indicateur"}</NoData>}
                    noHeader={true}
                    columns={indicsColumns}
                    persistTableHead
                    pagination
                    subHeader
                    highlightOnHover
                    pointerOnHover
                    data={filteredItemsCharts}
                    onRowClicked={(row) => {
                      let obj = indicatordata.find((o) => o.id === row.id);
                      if (obj) {
                        handleSubmit(obj);
                      }
                    }
                    }
                    paginationComponentOptions={{
                      noRowsPerPage: false,
                      rowsPerPageText: "Lignes par page",
                      rangeSeparatorText: "sur",
                      selectAllRowsItem: false,
                      selectAllRowsItemText: "Selectionner toutes les lignes",
                    }}
                    defaultPageSize={10}
                    filterable={true}
                    defaultSortFieldId={1}
                    manual={true}
                    paginationResetDefaultPage={resetPaginationToggleChart}
                    subHeaderComponent={subHeaderComponentMemoChart}
                  />
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </form>

    </>
  );
}

export default AddIndicDialog;
